import { Controller } from 'stimulus';

class FileUploadController extends Controller {
  static targets = ['input', 'fileIndicator'];

  /**
   * Change handler to indicate the file uploaded for a
   * file input field. Grabs the value of the uploaded file and sets
   * the text content of the file indicator to the file name. This
   * provides user feedback by indicating the file chosen in the case that
   * the default file input element is hidden for styling purposes.
   *
   * @returns {void}
   */
  handleChange() {
    const maxFileSize = this.inputTarget.dataset.maxFileSize;
    const fileIndicator = this.fileIndicatorTarget;
    const inputValue = this.inputTarget.value.split('\\').pop();

    if (maxFileSize && this.inputTarget.files[0].size > maxFileSize) {
      fileIndicator.textContent = `Error: File must be smaller than ${Math.round(maxFileSize / 1024 / 1000)}MB.`;
    } else {
      fileIndicator.textContent = inputValue || 'No file selected';

      this.inputTarget.blur();
    }
  }
}

export default FileUploadController;
